export const API_CONFIG = {
  BASE_URL: 'https://peocit.on.joget.cloud/jw/api',
  API_ID: 'API-68baacf9-b65e-4c7c-84e4-55c1f93a8e66',
  API_KEY: '657e5821943545be8643da30b7ee6bad',
  // API_NODE_BASE_URL: 'http://localhost:5000'  // ✅ Added here
  API_NODE_BASE_URL: 'https://mywplanapi.jacuji.com'  // ✅ Added here

};

  
export const LOOKUP_GROUPS = {
  GENDER: 'gender',
  OWNER_TYPE: 'assetOwnerType',
  ASSET_TYPE: 'assetType',
  ASSET_SUB_TYPE: 'assetSubType',
  MARITAL_STATUS: 'maretialStatus',
  EMPLOYMENT_STATUS: 'employmentStatus',

//  LIABILITY_OWNER_TYPE: 'liabilitiesOwnerType', // Fixed typo
  LIABILITY_TYPE: 'liabelitiesType',             // Fixed capitalization
  LIABILITY_SUB_TYPE: 'liabelitiesSubType',        // Fixed capitalization
  LIABILITY_FREQUENCY: 'liabilitiesFrequency',


  INSURANCE_FREQUENCY: 'insuranceInstallmentFrequency',
  INSURANCE_SUB_TYPE: 'insuranceSubType',
  INSURANCE_TYPE: 'insuranceType',

  INCOME_OWNER_TYPE: "incomeOwnerType",
  INCOME_TYPE: "incomeType",
  INCOME_SUB_TYPE: "incomeSubType",
  INCOME_FREQUENCY: "incomeFrequency",

  EXPENSE_OWNER_TYPE: "expenseOwnerType",
  EXPENSE_TYPE: "expenseType",
  EXPENSE_SUB_TYPE: "expenseSubType",
  EXPENSE_FREQUENCY: "expenseFrequency",

  GOAL_OWNER_TYPE: "goalOwnerType",
 GOAL_TYPE: "goalType",
   GOAL_SUB_TYPE: "goalSubType",
   GOAL_TARGET: "goalTarget",

   PROFILE_TYPE: "profileType",
   RELATION: "relation",
  DEPENDENTS: "dependents",
  PROFILE_PICTURE: "profilePicture",
  State: "State",
 
};



export default API_CONFIG;


